import React, {
  InputHTMLAttributes,
  ChangeEvent,
  useMemo,
  ReactNode,
} from "react";
import classnames from "classnames";

import { FormControlMessage } from "..";

import styles from "./Toggle.module.scss";

export interface Props
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "value" | "title"
  > {
  id: string;
  errorText?: string;
  hintText?: string | ReactNode;
  isError?: boolean;
  value?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>, value: boolean) => void;
  wrapperClassName?: string;
  messageClassName?: string;
}

const Toggle = (props: Props) => {
  const {
    id,
    value = false,
    hintText,
    errorText,
    isError,
    onChange,
    wrapperClassName,
    messageClassName,
    ...otherProps
  } = props;

  const showErrorMessage = !!errorText && isError;

  const describedBy = useMemo(() => {
    if (showErrorMessage) {
      return `${id}-error-msg`;
    }
    return undefined;
  }, [id, showErrorMessage]);

  return (
    <>
      <label>
        <span className={classnames(styles.toggleWrapper, wrapperClassName)}>
          <input
            id={id}
            type="checkbox"
            checked={value}
            aria-invalid={!!isError}
            aria-describedby={describedBy}
            className={styles.checkboxInput}
            onChange={(e) => onChange(e, e.target.checked)}
            {...otherProps}
          />
          <span
            className={classnames(styles.toggle, {
              [styles.onstyle]: value,
              [styles.offstyle]: !value,
            })}
          >
            <span className={styles.toggleHandle} />
          </span>
        </span>
      </label>
      <FormControlMessage
        id={id}
        errorText={errorText}
        hintText={hintText}
        isError={isError}
        className={classnames(styles.checkboxMessage, messageClassName)}
      />
    </>
  );
};

export default Toggle;
